(() => {
  const selectTab = (explorer, tab, focus = false) => {
    explorer.querySelectorAll('[data-tab]').forEach(button => {
      const selected = button === tab;
      button.setAttribute('aria-selected', String(selected));
      button.tabIndex = selected ? 0 : -1;
    });
    explorer.querySelectorAll('[data-panel]').forEach(panel => { panel.hidden = panel.dataset.panel !== tab.dataset.tab; });
    explorer.querySelectorAll('[data-screen]').forEach(screen => { screen.hidden = screen.dataset.screen !== tab.dataset.tab; });
    if (focus) tab.focus();
  };
  document.addEventListener('click', event => {
    const tab = event.target.closest('[data-tab]');
    if (tab) selectTab(tab.closest('[data-explorer]'), tab);
    const unavailable = event.target.closest('[data-unavailable]');
    if (unavailable) {
      const dialog = document.querySelector('#se-availability');
      const platform = unavailable.dataset.unavailable;
      dialog.querySelector('[data-availability-message]').textContent = `The public ${platform} download link will be added here when S&E is available. This page shows the invitation planned for launch.`;
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else window.alert(dialog.querySelector('[data-availability-message]').textContent);
    }
    if (event.target.closest('[data-close-dialog]')) document.querySelector('#se-availability')?.close();
    // Shopify Customer Events can subscribe without exposing any private app data.
    const store = event.target.closest('[data-store]');
    if (store && window.Shopify?.analytics?.publish) window.Shopify.analytics.publish('se_app_download_click', {platform: store.dataset.store});
  });
  document.addEventListener('keydown', event => {
    const tab = event.target.closest('[data-tab]');
    if (!tab || !['ArrowRight','ArrowLeft','Home','End'].includes(event.key)) return;
    const explorer = tab.closest('[data-explorer]');
    const tabs = [...explorer.querySelectorAll('[data-tab]')];
    let index = tabs.indexOf(tab);
    if (event.key === 'Home') index = 0;
    else if (event.key === 'End') index = tabs.length - 1;
    else index = (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    event.preventDefault();
    selectTab(explorer, tabs[index], true);
  });
  document.addEventListener('shopify:section:load', event => {
    const firstTab = event.target.querySelector('[data-tab]');
    if (firstTab) selectTab(firstTab.closest('[data-explorer]'), firstTab);
  });
})();
